import * as React from 'react';

type PropsLogoutButton = {
	logoutUrl: string;
	memberSite: string;
};

/**
 * Logout button component.
 *
 * Small form that allows the user to sign out via Institutes Single Sign-On
 * upon submission.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.logoutUrl - Institutes SSO logout URL.
 * @param {string} props.returnUrl - URL to return to after logout.
 *
 * @returns {React.Element} Institutes logout button component instance.
 */
export const LogoutButton: React.FC<PropsLogoutButton> = ({
	logoutUrl,
	memberSite,
}: PropsLogoutButton) => (
	<form method="POST" action={logoutUrl}>
		<input type="hidden" name="memberSite" value={memberSite} />
		<input type="hidden" name="returnUrl" value={window.location.href} />

		<input
			type="submit"
			className="btn btn--text flyout__link"
			value="Sign Out"
		/>
	</form>
);
